export default function MagnetIcon () {
  return (
    <svg width="16px" height="16px" viewBox="10 10 80 80">
      <path d="m84 10h-20c-1.1055 0-2 0.89453-2 2v42c0 6.6172-5.3828 12-12 12s-12-5.3828-12-12v-42c0-1.1055-0.89453-2-2-2h-20c-1.1055 0-2 0.89453-2 2v42c0 19.852 16.152 36 36 36s36-16.148 36-36v-42c0-1.1055-0.89453-2-2-2zm-2 4v14h-16v-14zm-48 0v14h-16v-14zm16 72c-17.645 0-32-14.355-32-32v-22h16v22c0 8.8242 7.1758 16 16 16s16-7.1758 16-16v-22h16v22c0 17.645-14.355 32-32 32z"/>
    </svg>
  );
}
